import React, { useState, useEffect } from "react";
import { Link, useNavigate  } from "react-router-dom";
import axios from "./api";
import AddWallet from "./AddWallet";
import "./dashboard.css";

function Dashboard() {
  // Demo wallet data
  const demoWallets = [
    { wallet: "Bitcoin Wallet", amount: "1.234", timestamp: new Date().toISOString() },
    { wallet: "Ethereum Wallet", amount: "5.678", timestamp: new Date().toISOString() },
    { wallet: "Litecoin Wallet", amount: "10.0", timestamp: new Date().toISOString() },
    { wallet: "Demo Wallet 1", amount: "2.5", timestamp: new Date().toISOString() },
    { wallet: "Demo Wallet 2", amount: "3.75", timestamp: new Date().toISOString() }
  ];

  // Demo automation statuses
  const demoAutomations = {
    make: "demo sent",
    zapier: "demo sent",
    n8n: "demo sent",
    monday: "demo sent",
    discord: "demo sent",
    telegram: "demo sent"
  };

  const [wallets, setWallets] = useState(demoWallets); 
  const [automationStatus, setAutomationStatus] = useState(demoAutomations);
  const [error, setError] = useState("");

  const fetchWallets = async () => {
    try {
      const res = await axios.get("/list-wallets/");
      setWallets(res.data.length ? res.data : demoWallets);
    } catch (err) {
      setError(err.response?.data?.detail || "Failed to fetch wallets");
      setWallets(demoWallets);
    }
  };

  const resetWallets = () => setWallets(demoWallets);
  
  const navigate = useNavigate();
  
  const handleLogout = () => {
    localStorage.removeItem("token");
    navigate("/login"); // React frontend route
  };

  useEffect(() => {
    fetchWallets();
  }, []);

  return (
    <div className="dashboard-container">
      {/* HEADER */}
      <div className="dashboard-header">
        <h2 className="dashboard-logo">Airdrop</h2>
        <div className="header-right">
          <Link to="/make" className="make-link">Make Integration</Link>
          <Link to="/monday" className="make-link">Monday.com Integration</Link>
          <Link to="/zapier" className="make-link">Zapier Integration</Link>
          <Link to="/n8n" className="make-link">n8n Integration</Link>
          <Link to="/discord" className="make-link">Discord Integration</Link>
          <Link to="/telegram" className="make-link">Telegram Integration</Link>
          <button className="logout-btn" onClick={handleLogout}>Logout</button>
        </div>
      </div>

      {/* HERO */}
      <div className="hero-card">
        <h1>Automate and Manage Your Crypto Rewards</h1>
        <p>
          Track your wallets, view balances, and connect to Make.com, Monday.com, Zapier, n8n,
          Discord, and Telegram to automate workflows and streamline your crypto management.
        </p>
      </div>

      {/* GRID */}
      <div className="grid">
        {/* TOTAL BALANCE */}
        <div className="card">
          <h3>Total Balance</h3>
          <div className="balance-value">
            €{" "}
            {wallets
              .reduce((acc, w) => acc + (parseFloat(w.amount) || 0), 0)
              .toLocaleString()}
          </div>
          <div className="add-wallet-section">
            <AddWallet fetchWallets={fetchWallets} />
            <button className="reset-btn" onClick={resetWallets}>Reset Wallets</button>
          </div>
          {error && <p className="error">{error}</p>}
        </div>

        {/* ACTIVITY CARD (aligned with features) */}
<div className="card activity-card">
  <h3>Activity</h3>
  <p className="activity-subtitle">Track your engagement and automation events</p>
  
  <div className="activity-header">
    <span>Mon</span><span>Tue</span><span>Wed</span>
    <span>Thu</span><span>Fri</span><span>Sat</span><span>Sun</span>
  </div>
  
  <div className="activity-container">
    {[...Array(42)].map((_, i) => (
      <div
        key={i}
        className={`activity-box ${
          i % 7 === 0 ? "heat-high" : i % 4 === 0 ? "heat-medium" : "heat-low"
        }`}
      />
    ))}
  </div>

  <div className="activity-stats">
    <div className="stat-box">
      <h4>Today</h4>
      <p>2h 15m</p>
    </div>
    <div className="stat-box">
      <h4>This Week</h4>
      <p>14h 12m</p>
    </div>
    <div className="stat-box">
      <h4>This Month</h4>
      <p>48h 47m</p>
    </div>
  </div>
</div>

        {/* WALLETS LIST */}
        <div className="card">
          <h3>Wallets</h3>
          <ul className="wallet-list">
            {wallets.map((w, i) => (
              <li key={i} className="wallet-item">
                <div>
                  <strong>{w.wallet}</strong>
                  <p className="date">{new Date(w.timestamp).toLocaleString()}</p>
                </div>
                <span className="amount">{w.amount}</span>
              </li>
            ))}
          </ul>
        </div>

        {/* AUTOMATIONS STATUS */}
        <div className="card">
          <h3>Automations</h3>
          <ul className="automation-list">
            {Object.entries(automationStatus).map(([name, status], i) => (
              <li key={i} className="automation-item">
                {["discord", "telegram"].includes(name) ? (
                  <Link 
                    to={`/${name}`} 
                    className={`automation-link ${name}`}
                  >
                    {name.charAt(0).toUpperCase() + name.slice(1)}
                  </Link>
                ) : (
                  <strong>{name.charAt(0).toUpperCase() + name.slice(1)}</strong>
                )}
                : <span>{status}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}

export default Dashboard;
